

<div class="season-save-dialog-container">
    <div class="season-save-dialog-header-container">
        <div>  <p class="season-save-dialog-header-text season-save-section-headers">SAVE DATA</p></div>
        <div><p class="season-save-dialog-sub-heading">Are you sure you want to save?</p></div>
    </div>

    <div class="season-save-btn-dialog-container">
        <button class="cancel-btn" mat-flat-button type="button" (click)="cancel()">
            <div class="cancel-btn-content">
                <span><p class="cancel-btn-text">CANCEL</p></span>
            </div>
        </button>

        <button class="basic-btn-white-font basic-btn-primary-bg" mat-flat-button type="button" (click)="save()">
            <div class="btn-content">
                <span><p class="btn-text">SAVE</p></span>
            </div>
        </button>
    </div>
</div>
